import './styles/FormButtonStyle.css';
interface FormButtonProps {
  content: string;
  disabled: boolean;
  onSubmit(): void;
  extraClassName?: string;
}

const FormButton: React.FC<FormButtonProps> = ({
  content,
  disabled,
  onSubmit,
  extraClassName,
}) => {
  return (
    <button
      className={`form-button ${extraClassName}`}
      disabled={disabled}
      onClick={() => onSubmit()}
    >
      {content}
    </button>
  );
};
export { FormButton };
